import { render } from "./CheckGroupBoxHorizontal.vue?vue&type=template&id=4e5fd476&scoped=true"
import script from "./CheckGroupBoxHorizontal.vue?vue&type=script&lang=js"
export * from "./CheckGroupBoxHorizontal.vue?vue&type=script&lang=js"

import "./CheckGroupBoxHorizontal.vue?vue&type=style&index=0&id=4e5fd476&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5fd476"]])

export default __exports__